import Origem, { IReferencia } from "./Origem";
import Pagamento from "./Pagamento/Pagamento";
import Rateio from "./Rateio";
import TituloSituacao, { EnumTituloSituacao } from "./TituloSituacao";
import { TypePessoa } from "../../Pessoa/Pessoa";

import dayjs from 'dayjs';
import { _MovimentacaoSemRecursao, Movimentacao } from "../Conta/Movimentacao";
import { DadosBancario } from "@/Models/Pessoa/DadosBancario";

type Titulo<TReferencia extends IReferencia = any, TReferenciaFatura extends IReferencia = TReferencia> = {
  codigo: number;
  codTipo: number|EnumTituloTipo;
  codFatura: number|null;
  fatura:Titulo<TReferenciaFatura>|null;
  codMovimentacao: number | null;
  movimentacao : Movimentacao | null;
  codOrigem: number;
  origem: Origem<TReferencia> | null;
  codTipoPessoaBeneficiario: number;
  pessoaTipoBeneficiario: any | null;
  codBeneficiario: number;
  beneficiario: TypePessoa | null;
  codTipoPessoaDevedor: number;
  pessoaTipoDevedor: any | null;
  codDevedor: number;
  devedor: TypePessoa | null;
  codDadosBancarioPagamento : number | null;
  dadosBancarioPagamento : DadosBancario | null;
  codSituacao: number | EnumTituloSituacao;
  situacao: TituloSituacao | null;
  rateios?: Rateio[];
  formasPagamento?: Pagamento[];
  parcelas: number;
  reembolsavel: boolean;
  comprovante:string|null;
  urlComprovante:string|null;
  descricao: string | null;
  dataEmissao: Date | dayjs.Dayjs;
  dataVencimento: Date | dayjs.Dayjs;
  dataPagamento: Date | null | dayjs.Dayjs;
  dataCredito: Date | null | dayjs.Dayjs;
  valorBase: number;
  valorPrevisto: number;
  valorDesconto: number | null;
  valorRecebido: number | null;
  valorJuros: number | null;
  valorMulta: number | null;
  ativo: boolean;
  dataCriacao: Date | dayjs.Dayjs;
  /**
   * Essa propriedade define que está fatura foi reembolsado.
   */
  codFaturaReembolso:number|undefined;
  /**
   * Essa propriedade define que está fatura reembolsou uma outra fatura.
   */
  codFaturaReembolsada:number|undefined;
};

export enum EnumTipoConsultaData {
  DataVencimento = 1,
  DataCriacao,
  DataPagamento, 
  DataCredito
}

export enum EnumTituloTipo {
  Titulo = 1,
  Parcela
}

export default Titulo;

// export type _TituloSemRecursao<T extends IReferencia = any> = Omit<Titulo<T>, "movimentacao" | "rateios" | "formasPagamento">;
export type _TituloSemRecursao<T extends IReferencia = any> = Omit<Titulo<T>, "movimentacao"> & {
  movimentacao: _MovimentacaoSemRecursao
};